import {
  useGlobalFilter,
  useTable,
  useSortBy,
  usePagination,
} from 'react-table';

/*
The useTable instance is documented here:
https://github.com/tannerlinsley/react-table/blob/master/docs/src/pages/docs/api/useTable.md#instance-properties
The useSortBy instance is documented here:
https://github.com/tannerlinsley/react-table/blob/master/docs/src/pages/docs/api/useSortBy.md#instance-properties
The usePagination instance is documented here:
https://github.com/tannerlinsley/react-table/blob/master/docs/src/pages/docs/api/usePagination.md#instance-properties
The useGlobalFilter instance is documented here:
https://github.com/tannerlinsley/react-table/blob/master/docs/src/pages/docs/api/useGlobalFilter.md#instance-properties
*/
const usePaginationTableWithSearch = ({
  columns,
  data,
  defaultPageSize,
  defaultSortId,
  defaultSortDesc = false,
}) => {
  const tableInstance = useTable(
    {
      columns,
      data,
      initialState: {
        pageIndex: 0,
        pageSize: defaultPageSize || 10,
        sortBy: [{ id: defaultSortId, desc: defaultSortDesc }],
      },
    },
    useGlobalFilter,
    useSortBy,
    usePagination,
  );
  return { columnsLength: columns.length, ...tableInstance };
};

export default usePaginationTableWithSearch;
